module.exports = __webpack_public_path__ + "img/prize-02.9733f8a7.png";